<ng-container>
  @if (!canOpen) {
    <div class="transaction-list-header__top">
      <div class="transaction-list-header__item-title-first"></div>
      <div class="transaction-list-header__item-title large-weight font-size-15">
        {{ "transaction_list_item_header" | translate }}
      </div>
      <div class="transaction-list-header__close-icon">
        <div
          class="transaction-list-header__close-icon-wrapper"
          (keydown.enter)="closeEmitter?.emit()"
          (click)="closeEmitter?.emit()"
          tabindex="0">
          <span class="bpi__icon-close"></span>
        </div>
      </div>
    </div>
    <hr class="mt-0 mb-0" />
  }
  <div
    class="transaction-list-header__container"
		[ngClass]="{
			isOpen: !canOpen,
			'hover-pointer': canOpen && isActivityOrHistory(),
			isActivity: isActivityOrHistory(),
			isIndexDetail: isIndexDetail()
		}">
    <div class="column-symbols" [ngClass]="{ isActivity: isActivityOrHistory() }">
      <div class="symbols-container">
        <ng-content select="[symbol]"></ng-content>
      </div>
    </div>
    <div
      class="transaction-header-container"
			[ngClass]="{
				isOpen: !canOpen,
				isActivity: isActivity,
				isHistory: isHistory
			}">
      <div class="transaction-header-grid-item mod-item-one" [ngClass]="{ isActivity: isActivityOrHistory() }">
        <div class="information-header">
          <span class="information-header-title flex-center-vertical">
            <span class="information-trade-title">
              <ng-content select="[status]"></ng-content>
              @if (showTxItemTitle()) {
                @if (!isVoucherTx()) {
                  {{ "tx_list_item_" + transaction?.getType() | translate: [getAssetNameorSymbol()] }}
                } @else {
                  <span>
                    {{ "voucher_tx_item_header" | translate: [tradable?.getSymbol(false, true)] }}
                  </span>
                }
              }
              @if (!isMobileWindow) {
                <transaction-list-tag
                  [transaction]="transaction"
                  [canOpen]="canOpen"
                  class="inline-flex"
                ></transaction-list-tag>
              }
            </span>
          </span>
        </div>
      </div>
      <div
        class="transaction-header-grid-item mod-item-two mod-flex-end"
        [ngClass]="{ isActivity: isActivityOrHistory() }">
        <ng-content select="[amounts]"></ng-content>
      </div>
      <div class="transaction-header-grid-item mod-item-three">
        <div class="recipient-information">
          @if (transaction?.hasTrade() && !isDebitCardTx() && !isEarnOnFiatElement(transaction)) {
            @if (isFromPrefix()) {
              {{ "from" | translate }}: <span>{{ showTradeWalletName() }}</span>
              @if (isDeletedWallet()) {
                <small class="text-small-gray">
                  ({{ "deleted" | translate }})
                </small>
              }
            } @else {
              {{ "to" | translate }}:
              @if (transaction?.getTrade()?.hasProvider()) {
                {{ getProvider()?.getName() }}
              } @else {
                {{ showTradeWalletName() }}
              }
              @if (isDeletedWallet(false)) {
                <small class="text-small-gray">
                  ({{ "deleted" | translate }})
                </small>
              }
            }
          }
          <!-- simple transaction or IndexTrade-->
          @if (!transaction?.hasTrade()) {
            <ng-content select="[transaction]"></ng-content>
          }
          @if (isDebitCardTx()) {
            {{ "debit_card_tx_header_description" | translate }}
          }
        </div>
      </div>
      @if (isMobileWindow) {
        <transaction-list-tag
          class="transaction-list-tag"
          [transaction]="transaction"
          [canOpen]="canOpen"
					[ngClass]="{
						'pt-5': isMobileWindow && !canOpen
					}"></transaction-list-tag>
      }
      <div class="transaction-header-grid-item mod-item-four mod-flex-end">
        <ng-content select="[amountsExchanged]"></ng-content>
      </div>
    </div>
  </div>
</ng-container>
